/**
 * Both `200…` and `300…` prefixes are in service, so only the digit shape is validated. Zero is
 * rejected so an unpopulated field falls through to the silhouette instead of requesting stock 0.
 */
export const toStockNumber = (stockNumber?: number | string | null): string | null => {
  const value = String(stockNumber ?? '').trim();

  return /^\d+$/.test(value) && Number(value) > 0 ? value : null;
};
